import { Nullable } from '@orcar/common';
import {
  getDateOptionTextWithTime,
  getHMFromNumber,
  getHoursDiffCeilMinutes,
  getPrimaryColor,
  hoursToText,
  Icon,
  JEJURO,
} from '@orcar/common-d2c';
import dayjs, { Dayjs } from 'dayjs';
import styled from 'styled-components';
import NoteIcon from '@/assets/icon/event_note.svg';
import CarIcon from '@/assets/icon/no_crash.svg';

type MobileSearchBoxProps = {
  pickUpAt: Dayjs;
  dropOffAt: Dayjs;
  onRentalPeriodClick: () => void;
  onSearchButtonClick: () => void;
};

const MobileSearchBox = ({
  pickUpAt,
  dropOffAt,
  onRentalPeriodClick,
  onSearchButtonClick,
}: MobileSearchBoxProps) => {
  const rentalHour = getHoursDiffCeilMinutes(pickUpAt, dropOffAt);

  return (
    <Wrapper>
      <TextWrapper onClick={onRentalPeriodClick}>
        <Icon src={NoteIcon} width={24} height={24} />
        <Text>
          {getDateOptionTextWithTime(pickUpAt, dropOffAt, true, true) ||
            '여행 일정'}
        </Text>
      </TextWrapper>
      <Divider />
      <TextWrapper onClick={onRentalPeriodClick}>
        <Icon src={CarIcon} width={24} height={24} />
        <Text>{hoursToText(rentalHour) || '총 이용 시간'}</Text>
      </TextWrapper>
      <Button onClick={onSearchButtonClick}>검색하기</Button>
    </Wrapper>
  );
};

export default MobileSearchBox;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 320px;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 50px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: var(--Color, #fff);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.07);
`;

const TextWrapper = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px 0 16px 0;
  width: 100%;
`;

const Text = styled.span`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.COLOR.GREY_02};
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.24px;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #ececec;
`;

const Button = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.COLOR.WHITE};
  background-color: ${getPrimaryColor(JEJURO)};
  border-radius: 0px 0px 8px 8px;
`;
